import { generateGuid } from '~/utils/auth';
import useCredsystemAuthStore from '~/credsystem/stores/credsystemAuth';
import { CredsystemLocalStorage } from '~/credsystem/storage/LocalStorage';
import { CREDSYSTEM_APP_UID } from '~/credsystem/storage/constants';

const initCredsystemUser = async () => {
  const uid = generateGuid({
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
    size: 21,
  });

  const appUid = await CredsystemLocalStorage.get(CREDSYSTEM_APP_UID);

  if (!appUid) {
    CredsystemLocalStorage.set(CREDSYSTEM_APP_UID, uid);
  }

  await useCredsystemAuthStore.getState().init();
};

export default initCredsystemUser;
